/**
 * Vietnamese render vocabulary.
 *
 * Self-registering: importing this module makes the words available to
 * `render(node, 'vi')`. Kept separate from the profile so a parse-only
 * bundle can drop it — see lexicon-registry.ts for why that separation exists.
 */
import type { LanguageLexicon } from '../generators/profiles/types';
import { registerLexicon } from '../lexicon-registry';

export const vietnameseLexicon: LanguageLexicon = {
  events: {
    blur: { primary: 'blur' },
    change: { primary: 'change' },
    click: { primary: 'nhấp' },
    dblclick: { primary: 'dblclick' },
    focus: { primary: 'focus' },
    input: { primary: 'nhập' },
    keydown: { primary: 'keydown' },
    keypress: { primary: 'keypress' },
    keyup: { primary: 'keyup' },
    load: { primary: 'load' },
    mouseenter: { primary: 'mouseenter' },
    mouseleave: { primary: 'mouseleave' },
    mouseout: { primary: 'mouseout' },
    mouseover: { primary: 'mouseover' },
    reset: { primary: 'reset' },
    resize: { primary: 'đổi kích thước' },
    scroll: { primary: 'cuộn' },
    submit: { primary: 'nộp' },
  },
  logical: {
    and: { primary: 'và' },
    changes: { primary: 'thay đổi' },
    contains: { primary: 'chứa' },
    else: { primary: 'không thì' },
    empty: { primary: 'trống' },
    end: { primary: 'kết thúc' },
    equals: { primary: 'bằng' },
    exists: { primary: 'tồn tại' },
    false: { primary: 'sai' },
    has: { primary: 'có' },
    have: { primary: 'có' },
    is: { primary: 'là' },
    live: { primary: 'live' },
    matches: { primary: 'khớp' },
    not: { primary: 'không' },
    null: { primary: 'rỗng' },
    or: { primary: 'hoặc' },
    then: { primary: 'rồi' },
    true: { primary: 'đúng' },
    when: { primary: 'khi' },
    where: { primary: 'ở_đâu' },
  },
  temporal: {
    always: { primary: 'luôn luôn' },
    forever: { primary: 'mãi mãi' },
    never: { primary: 'không bao giờ' },
    now: { primary: 'bây giờ' },
    once: { primary: 'một lần' },
    sometimes: { primary: 'đôi khi' },
    times: { primary: 'lần' },
    today: { primary: 'hôm nay' },
    tomorrow: { primary: 'ngày mai' },
    twice: { primary: 'hai lần' },
    yesterday: { primary: 'hôm qua' },
  },
  values: {
    all: { primary: 'tất cả' },
    any: { primary: 'bất kỳ' },
    body: { primary: 'body' },
    each: { primary: 'mỗi' },
    event: { primary: 'sự kiện' },
    every: { primary: 'tất cả' },
    false: { primary: 'sai' },
    it: { primary: 'nó' },
    its: { primary: 'của nó' },
    me: { primary: 'tôi' },
    my: { primary: 'của tôi' },
    none: { primary: 'không có' },
    null: { primary: 'rỗng' },
    result: { primary: 'kết quả' },
    some: { primary: 'một số' },
    target: { primary: 'mục tiêu' },
    true: { primary: 'đúng' },
    undefined: { primary: 'không xác định' },
    you: { primary: 'bạn' },
    your: { primary: 'của bạn' },
  },
  attributes: {
    checked: { primary: 'được chọn' },
    class: { primary: 'lớp' },
    disabled: { primary: 'vô hiệu' },
    hidden: { primary: 'ẩn' },
    href: { primary: 'liên kết' },
    html: { primary: 'html' },
    id: { primary: 'id' },
    selected: { primary: 'được chọn' },
    src: { primary: 'nguồn' },
    style: { primary: 'kiểu' },
    text: { primary: 'văn bản' },
    value: { primary: 'giá trị' },
  },
  expressions: {
    characters: { primary: 'ký tự' },
    children: { primary: 'con' },
    closest: { primary: 'gần nhất' },
    empty: { primary: 'làm-rỗng' },
    'ends with': { primary: 'kết thúc bằng' },
    event: { primary: 'sự kiện' },
    exclusive: { primary: 'loại trừ' },
    first: { primary: 'đầu tiên' },
    'ignoring case': { primary: 'không phân biệt hoa thường' },
    inclusive: { primary: 'bao gồm' },
    it: { primary: 'nó' },
    its: { primary: 'của nó' },
    'joined by': { primary: 'nối bởi' },
    last: { primary: 'cuối cùng' },
    'mapped to': { primary: 'ánh xạ thành' },
    me: { primary: 'tôi' },
    my: { primary: 'của tôi' },
    next: { primary: 'tiếp theo' },
    parent: { primary: 'cha' },
    previous: { primary: 'trước đó' },
    random: { primary: 'ngẫu nhiên' },
    result: { primary: 'kết quả' },
    'sorted by': { primary: 'sắp xếp theo' },
    'split by': { primary: 'tách bởi' },
    'starts with': { primary: 'bắt đầu bằng' },
    target: { primary: 'mục tiêu' },
  },
};

registerLexicon('vi', vietnameseLexicon);
